<template>
  <div id="app">
    <router-view
      class="container"
      keep-alive
      transition
      transition-mode="out-in"
    >
    </router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  #app{
    width: 100%;
    height: 100%;
  }
  html, body, div, p, h1, h2, h3, h4, h5, ol, ul, li, dl, dt, dd, form, input, textarea, select, span, table, tr, td, img {
    margin: 0;
    padding: 0;
    border: 0;
  }
  html, body {
    background:rgba(255,255,255,0.94);
    color: rgba(122,122,122,1);
    font-family: "HYQiHei-EES", "Hiragino Sans GB", "Noto Sans", "MicrosoftYahei", "Helvetica Neue", "Arial";
    user-select: none;
    -webkit-user-select: none;
    -webkit-touch-callout:none;
    -webkit-font-smoothing: antialiased;
    font-size: 0.32rem;
    background: url("./assets/home_bg.png");
    background-size: 100% 100%;
    color: rgba(122,122,122,1);
    width: 100%;
    height: 100%;
    /*height: 100%*/
  }

  body{
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  *:focus, *:hover {
    outline: none;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    -webkit-tap-highlight-color: transparent;
  }
  :not(input,textarea) {
    -webkit-touch-callout: none;
    -webkit-user-select: element;
    user-select: element;
  }
  input, textarea {
    box-shadow:0px 0px 0px rgba(0,0,0,0);
    -webkit-appearance: none;
  }
  input, textarea {
    outline: none;
    border: none;
    border-radius: 0;
  }
  input::-moz-focus-inner,input::-webkit-focus-inner,input::focus-inner {
    border: 0;
  }
  textarea {
    resize: none;
  }
  ul, ol, li {
    list-style: none;
  }
  a {
    text-decoration: none;
    color: #333;
    outline: none;
  }
  a,input{
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    -webkit-tap-highlight-color: transparent;
  }
  a:focus, input:focus {
    outline: 0;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    -webkit-tap-highlight-color: transparent;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue